import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IGreenhouseGoalTermFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_GOAL_TERM_REMARK_ID = 'gh-goal-term-remark';

const GreenhouseGoalTermRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`greenhouseGoalTerm`) ?? ({} as IGreenhouseGoalTermFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghGoalTermRemarkEl = document.getElementById(GH_GOAL_TERM_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'greenhouseGoalTerm',
      control,
    }) ?? ({} as IGreenhouseGoalTermFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGoalTermRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกระยะสั้น (short term) และ/หรือระยะยาว (long term)"
              setOpen={open}
              fieldPath="greenhouseGoalTerm.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGoalTermRemarkEl
        )}
    </>
  );
};

export default GreenhouseGoalTermRemark;
